import { faArrowDown, faArrowUp, faBox, faCalendarDay, faCartShopping, faFutbol, faHatChef, faLightbulb, faMoneyBillTrendUp, faPeopleGroup, faQuestion, faSkullCrossbones, faSliders, faStopwatch, faUserLargeSlash, faWarning } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { FormatNumber } from "src/app/helpers/Index";
import { colours } from "src/app/Styles";
import "./AdminSuperAdmin.css";
import { NavLink } from "react-router-dom";
import { environment } from "src/environments/environment";

type Props = {};
type State = {
	dishBreakdown: any[];
	dishBreakdownTotal: number;
	notifications: any;
	salesOverview: any[];
	upcomingOrders: any[];
};
export class AdminSuperAdmin extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { dishBreakdown: [], dishBreakdownTotal: 0, notifications: [], salesOverview: [], upcomingOrders: [] };
	}

	componentDidMount() {
		this.getDishBreakdown();
		this.getNotifications();
		this.getSalesOverview();
		this.getUpcomingOrders();
	}

	getDishBreakdown() {
		const data = [
			{ name: "Marshall", sold: 52 },
			{ name: "BW Shirmpton", sold: 41 },
			{ name: "Mortz", sold: 38 },
			{ name: "AMS", sold: 34 }
		];
		let total = 0;
		data.forEach((dish) => total += dish.sold);
		data.sort((a, b) => {
			if (a.sold > b.sold) return -1;
			else if (a.sold < b.sold) return 1;
			else return 0;
		});
		this.setState({ dishBreakdown: data, dishBreakdownTotal: total });
	}

	getNotifications() {
		const data = [
			{
				day: "Today", notifications: [
					{ message: "DAGGERS has submitted a new team sheet", type: "ALLERGEN" },
					{ message: "Debug Labs purchased a new sponsorship", type: "REVIEW" }
				]
			},
			{
				day: "Yesterday", notifications: [
					{ message: "Glyn Sparks add a new sponsor", type: "CUSTOMER" },
					{ message: "Debug Labs purchased a new sponsorship", type: "REVIEW" },
					{ message: "AMS sponsored Ogle (2)", type: "" }
				]
			}
		];
		this.setState({ notifications: data });
	}

	getNumericColor(value: number) {
		switch (value) {
			case 0:
				return colours.graphs.primary;
			case 1:
				return colours.graphs.secondary;
			case 2:
				return colours.graphs.tertiary;
			case 3:
				return colours.graphs.quaternary;
			default:
				return colours.graphs.primary;
		}
	}

	getSalesOverview() {
		const data = [{}];
		this.setState({ salesOverview: data });
	}

	getUpcomingOrders() {
		const data = [{}];
		this.setState({ upcomingOrders: data });
	}

	render() {
		return (
			<>
				<Row>
					<Col lg={6} xl={3} xs={12}>
				<div className="admin-tile">
			<div className="tile position-relative pointer">
				<FontAwesomeIcon icon={faStopwatch} style={{color: colours.primary, fontSize: "30pt"}} className="sa-icon"/>
				<span className="position-absolute start-50 translate-middle-x text-center">Sponsorship Types</span>
			</div>
		</div>
		</Col>
		<Col lg={6} xl={3} xs={12}>
		<NavLink to={`/${environment.build.adminRoute}/users`}>
				<div className="admin-tile">
			<div className="tile position-relative pointer">
				<FontAwesomeIcon icon={faLightbulb} style={{color: colours.primary, fontSize: "30pt"}} className="sa-icon"/>
				<span className="position-absolute start-50 translate-middle-x text-center">Users</span>
			</div>
		</div>
		</NavLink>
		</Col>
		<Col lg={6} xl={3} xs={12}>
				<div className="admin-tile">
			<div className="tile position-relative pointer">
				<FontAwesomeIcon icon={faSliders} style={{color: colours.primary, fontSize: "30pt"}} className="sa-icon"/>
				<span className="position-absolute start-50 translate-middle-x text-center">System Settings</span>
			</div>
		</div>
		</Col>
				</Row>
			</>
		);
	}

	renderNotifications() {
		return (
			<div className="card" style={{ padding: "1.5rem" }}>
				<h5>Activity</h5>
				{/* <h5 style={{marginBottom: 16}}>Notifications</h5> */}
				{this.state.notifications.map((data: any) => {
					return (
						<div key={`notification-day-${data.day}`} style={{ marginTop: 24 }}>
							<span style={{ color: colours.septenary, fontSize: 15, fontWeight: "bold", marginBottom: 12, textTransform: "uppercase" }}>{data.day}</span>
							{data.notifications.map((notification: any, i: number) => {
								let backgroundColour = "";
								let colour = "";
								let icon;

								switch (notification.type) {
									case "REVIEW":
										backgroundColour = colours.graphs.negativeBg;
										colour = colours.graphs.negative;
										icon = faWarning;
										break;
									case "ALLERGEN":
										backgroundColour = colours.graphs.secondaryBg;
										colour = colours.graphs.secondary;
										icon = faSkullCrossbones;
										break;
									case "CUSTOMER":
										backgroundColour = colours.graphs.tertiaryBg;
										colour = colours.graphs.tertiary;
										icon = faUserLargeSlash;
										break;
									default:
										backgroundColour = colours.graphs.quaternaryBg;
										colour = colours.graphs.quaternary;
										icon = faQuestion;
										break;
								}

								return (
									<div key={`notification-${data.day}-${i}`} style={{ alignItems: "center", borderBottomWidth: i === data.notifications.length - 1 ? 0 : 1, borderColor: colours.quaternary, borderStyle: "solid", borderLeftWidth: 0, borderRightWidth: 0, borderTopWidth: 0, display: "flex", height: 50 }}>
										<div className="d-flex align-items-center justify-content-center" style={{ backgroundColor: backgroundColour, height: "2.5rem", width: "2.5rem" }}>
											<FontAwesomeIcon icon={icon} style={{ color: colour, fontSize: "1.25rem" }} />
										</div>
										<span style={{ color: colours.septenary, fontSize: 15, marginLeft: 8 }}>{notification.message}</span>
									</div>
								);
							})}
						</div>
					);
				})}
			</div>
		);
	}
}